import { render, staticRenderFns } from "./RegistrationMailErrorDialog.vue?vue&type=template&id=11f8f1f6"
import script from "./RegistrationMailErrorDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationMailErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports